import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetImageStyle0 = gravityIconIndividualCss;

const GravityIconAssetImage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'f6f4543ceb1cc35d7c858fe52913b1e2fc87b981', color: this.color, size: this.size }, h("svg", { key: '44e6cdb3c846fd483164a983caedd55dec20c717', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '82660cf7fbdae3fc353551f82fbbde125177e002', d: "M12.82 10.11 10.14 14l-1.82-2.65a.24.24 0 0 0-.39 0L6 14.13a.23.23 0 0 0 .19.37h9.6a.23.23 0 0 0 .19-.37l-2.78-4a.24.24 0 0 0-.38-.02Zm-1.901-.998a1.17 1.17 0 0 1-1.089.718c-.64 0-1.16-.52-1.16-1.16a1.17 1.17 0 1 1 2.249.442Z", fill: "currentColor" }), h("path", { key: 'ac426bfb0231db7065875cbe755f930be211efe2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm16.5 12v-11h-15v11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetImage.style = GravityIconAssetImageStyle0;

export { GravityIconAssetImage as gravity_icon_asset_image };

//# sourceMappingURL=gravity-icon-asset-image.entry.js.map